/* eslint-disable */
import { CardProps, Card as MCard, Stack, styled } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import { Typography } from '../Typography/Typography';

interface ICardProps extends Omit<CardProps, 'title'> {
  title?: string | React.ReactElement;
  padded?: boolean;
  actions?: Array<React.ReactNode>;
  titleMargin?: string;
}

const StyledCard = styled(MCard)<ICardProps>(({ theme, padded, variant }) => ({
  // Apply theme overrides
  borderRadius: '4px !important',
  border: '0px solid rgb(154, 154, 154) !important',
  // boxShadow: '2px 1px 5px 1px grey !important',
  backgroundColor: theme.palette.primary.main,
  padding: padded ? theme.spacing(2) : 0,
  ...(variant === 'outlined' && {
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: 'none'
  })
}));

const CardTitle = styled('div')({
  marginBottom: '15px'
});

/**
 * Card component
 */
export const Card: React.FC<ICardProps & PropsWithChildren> = ({
  children,
  title = '',
  padded = true,
  actions,
  titleMargin = '10px',
  ...props
}) => {
  return (
    <StyledCard padded={padded} {...props}>
      {(title || actions) && (
        <Stack
          direction="row"
          justifyContent="space-between"
          style={{ marginBottom: titleMargin }}
        >
          <CardTitle>
            <Typography variant="subtitle2" style={{ fontWeight: '700' }}>
              {title}
            </Typography>
          </CardTitle>
          {actions && (
            <Stack direction="row" spacing={2}>
              {actions}
            </Stack>
          )}
        </Stack>
      )}
      {children}
    </StyledCard>
  );
};

export default Card;
